document.querySelector('html').classList.add('js');

const fileInput = document.querySelector('.input__file-inner'),
  button = document.querySelector('.input__file-trigger'),
  the_return = document.querySelector('.input__file-return');

button.addEventListener('keydown', function (event) {
  if (event.keyCode == 13 || event.keyCode == 32) {
    fileInput.focus();
  }
});

button.addEventListener('click', function (event) {
  fileInput.focus();
  return false;
});

fileInput.addEventListener('change', function (event) {
  the_return.innerHTML = this.value;
});
